import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../../../../../shared/helpers';
import {Link} from 'react-router-dom';
import {useTheme} from '@emotion/react';

// components
import {CardBorder} from '../../../../../../shared/components';
import {Button, Divider} from '@mui/joy';

// styles
import {
  CardSubscriptionBottom,
  CardSubscriptionBottomLeft,
  CardSubscriptionBottomLeftItem,
  CardSubscriptionTop,
  CardSubscriptionTopLeft,
  CardSubscriptionWrapper,
} from './CardSubscription-styles';

// types
import {Subscription} from '../../../../../../shared/services/ApiService/types';
import {
  IconRightArrow,
  Subtitle,
  TextColors,
  TextDefault,
  TextExtraSmall,
  TextSmall,
} from '../../../../../../shared/styles';

type Props = {
  subscription: Subscription;
};

const CardSubscription = ({subscription}: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <CardBorder variant="grey">
      <CardSubscriptionWrapper>
        <CardSubscriptionTop>
          <CardSubscriptionTopLeft>
            <Subtitle bold="bold" color={TextColors.brand}>{`#${
              subscription.subscriptionNumber
            }`}</Subtitle>
            <TextSmall bold="bold">{subscription.status}</TextSmall>
          </CardSubscriptionTopLeft>
          <TextExtraSmall bold="bold">{subscription.startDate}</TextExtraSmall>
        </CardSubscriptionTop>
        <Divider />
        <CardSubscriptionBottom>
          <CardSubscriptionBottomLeft>
            <CardSubscriptionBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('subscription_amount_short')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(subscription.amount)}
              </TextDefault>
            </CardSubscriptionBottomLeftItem>
            <CardSubscriptionBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('global_totalOwing')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(subscription.totalOwing)}
              </TextDefault>
            </CardSubscriptionBottomLeftItem>
          </CardSubscriptionBottomLeft>
          <Button
            style={{
              minWidth: '104px',
              minHeight: '40px',
              borderRadius: theme.border.radius.xxs,
            }}
            variant="outlined"
            endDecorator={<IconRightArrow />}
            component={Link}
            to={`/subscriptions/${subscription.id}`}>
            {t('global_details')}
          </Button>
        </CardSubscriptionBottom>
      </CardSubscriptionWrapper>
    </CardBorder>
  );
};

export default CardSubscription;
